export default {
  props: {
    itemData: {
      type: [Object, String, Number, Boolean, Array, Function],
      default: null,
    },
    label: {
      type: [String, Object, Number, Boolean, Array, Function],
      default: 'No item label defined',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    children: {
      type: Array,
      default: () => null,
    },
    itemContainerStyle: {
      type: Object,
      default: () => {},
    },
    childItemChildrenMapper: {
      type: Function,
      default: (item) => item?.children,
    },
    childItemDisabledMapper: {
      type: Function,
      default: () => false,
    },
    childItemKeyMapper: {
      type: Function,
      default: (item, index) => index,
    },
    childItemLabelMapper: {
      type: Function,
      default: (item) => item,
    },
    level: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    slots() {
      return Object.keys(this.$scopedSlots);
    },
    isParent() {
      return Array.isArray(this.children);
    },
    itemContainerStyles() {
      return {
        ...this.itemContainerStyle,
        paddingLeft: `${this.level}em`,
      };
    },
  },
  methods: {
    emitClickEvent() {
      if (!this.isDisabled) {
        this.$emit('click');
      }
    },
    emitChildClickEvent(childItem, childIndex) {
      this.$emit('child-click', childItem, childIndex);
    },
  },
};
